import { render, staticRenderFns } from "./WorkUploadZone.vue?vue&type=template&id=1f7cf902&scoped=true"
import script from "./WorkUploadZone.vue?vue&type=script&lang=js"
export * from "./WorkUploadZone.vue?vue&type=script&lang=js"
import style0 from "./WorkUploadZone.vue?vue&type=style&index=0&id=1f7cf902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cf902",
  null
  
)

export default component.exports